//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.SheetMetal.js";
import "../no/TaggedObject.js";
import "../no/Expression.js";
let d=[[[1,"BendRadius",0,"Expression",0],[1,"BendReliefDepth",0,"Expression",0],[0,"BendReliefType",1,0],[1,"BendReliefWidth",0,"Expression",0],[0,"CornerReliefType",1,0],[0,"DieToolId",1,0],[0,"DieToolIdName",1,0],[0,"ExtendBendRelief",1,0],[0,"IncludeReliefInWidth",1,0],[1,"NeutralFactor",0,"Expression",0],[0,"OverrideToolSet",1,0],[0,"PunchToolId",1,0],[0,"PunchToolIdName",1,0],[0,"UseGlobalBendRadius",1,0],[0,"UseGlobalNeutralFactor",1,0],[0,"UseGlobalReliefDepth",1,0],[0,"UseGlobalReliefWidth",1,0]],[],[]];
SPLM.Features.SheetMetal.BendOptions = class extends SPLM.TaggedObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.SheetMetal.BendOptions";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.SheetMetal.BendOptions.BendReliefTypeOptions = Object.freeze({
    "None" : "None", "Square" : "Square", "Round" : "Round"});

SPLM.Features.SheetMetal.BendOptions.CornerReliefTypeOptions = Object.freeze({
    "None" : "None", "BendOnly" : "BendOnly", "BendAndFace" : "BendAndFace", "BendAndFaceChain" : "BendAndFaceChain"});

export default SPLM;